import { render } from "./MembersListReport.vue?vue&type=template&id=48020b32&scoped=true"
import script from "./MembersListReport.vue?vue&type=script&lang=js"
export * from "./MembersListReport.vue?vue&type=script&lang=js"

import "./MembersListReport.vue?vue&type=style&index=0&id=48020b32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48020b32"]])

export default __exports__